import React from "react";
import { HashLink as Link } from "react-router-hash-link";
import NavBar from "../general/navBar";
import tool from "../../assets/img/illu/tool.png";
import icon1 from "../../assets/img/ico/tool/ico1.png";
import icon2 from "../../assets/img/ico/tool/ico2.png";
import icon3 from "../../assets/img/ico/tool/ico3.png";

const Tool = () => {
  return (
    <section className="tool-section">
      <p className="tag green">Un compte en ligne pensé pour vous</p>
      <h2>Des outils pensés pour vous</h2>
      <p>
        Gérez votre activité simplement et efficacement grâce à une plateforme
        <br />
        intuitive et exclusive signée Agileom.
      </p>
      <ul className="tool-list">
        <li className="tool-item">
          <img src={icon1} alt="" />
          <p>Suivi en temps réel</p>
        </li>
        <li className="tool-item">
          <img src={icon2} alt="" />
          <p>Gestion centralisée</p>
        </li>
        <li className="tool-item">
          <img src={icon3} alt="" />
          <p>Statistiques détaillées</p>
        </li>
      </ul>
      <article>
        <div>
          <h3>
            Prêt à recruter avec
            <br /> Agileom ?
          </h3>
          <a className="btn fill white btn-tool" href="#">
            <i class="fa-solid fa-phone"></i>
            rappeler
          </a>
        </div>
        <img src={tool} alt="" />
      </article>
    </section>
  );
};

export default Tool;
